import React, { useState, useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles, Theme } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router";
import { Avatar } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import Box from "@material-ui/core/Box";
import InputAdornment from "@material-ui/core/InputAdornment";
import { RadioGroup } from "@material-ui/core";
import { AppDispatch } from "../../app/store";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMedia from "use-media";
import Paper from "@material-ui/core/Paper";

import {
  selectEditedProfile,
  fetchAsyncUpdateProfile,
} from "../auth/authSlice";

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  paper: {
    margin: theme.spacing(4, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  flex: {
    flexDirection: "unset",
    flexWrap: "unset",
    justifyContent: "space-around",
    width: "100%",
  },
  radioLabel: {
    fontSize: "14px",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
  radioText: {
    fontSize: 14,
  },
  text: {
    fontSize: 12,
    color: "#444444",
    paddingTop: theme.spacing(2),
    width: "100%",
  },
  submit: {
    padding: theme.spacing(1, 5),
    backgroundColor: "#2699FB",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(1),
    position: "fixed",
    width: "100%",
    top: 0,
    zIndex: 3,
    maxWidth: "66.667%",
  },
  headerRes: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(1),
    position: "fixed",
    width: "100%",
    top: 0,
    zIndex: 3,
  },
  headerBack: {
    paddingLeft: theme.spacing(3),
  },
  headerSubmit: {
    paddingRight: theme.spacing(3),
  },
  avatar: {
    width: "100%",
    height: "100%",
  },
  avatarContainer: {
    height: "150px",
    width: "150px",
    margin: theme.spacing(0, "auto"),
    paddingBottom: theme.spacing(3),
  },
  avatarBtn: {
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    cursor: "pointer",
    height: "100%",
    width: "100%",
    position: "relative",
    padding: "unset",
  },
  imgSelect: {
    position: "absolute",
    zIndex: 2,
    top: "43%",
    left: "20%",
    fontSize: "18px",
    color: "#444444",
  },
  switchBtn: {
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.spacing(1),
  },
  textarea: {
    borderRadius: 5,
    width: "100%",
    borderColor: "rgba(0, 0, 0, 0.23)",
    padding: 12,
    boxSizing: "border-box",
    marginTop: theme.spacing(2),
    color: "#444444",
    "&:focus-visible": {
      outline: "1px #3f51b5 auto",
    },
    fontSize: 16,
  },
  paperContainer: {
    marginTop: theme.spacing(7),
    paddingBottom: theme.spacing(5),
  },
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "green",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
  },
  textCount: {
    width: "100%",
    textAlign: "right",
    paddingTop: 3,
    color: "#555555",
  },
  color: {
    color: "#444444",
  },
  textSub: {
    fontSize: 12,
    color: "#555555",
    width: "100%",
    textAlign: "right",
    paddingBottom: theme.spacing(1),
  },
  container: {
    position: "relative",
  },
  circulContainer: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    zIndex: 3,
  },
  circul: {
    height: "100px !important",
    width: "100px !important",
  },
  headerWhite: {
    margin: "0 8px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    padding: "8px 0",
  },
  bodyWhite: {
    margin: "0 8px",
    background: "#ffffff",
    width: "100%",
    padding: "10px 16px 40px 16px",
    height: "100%",
  },
}));

const ProfileEdit: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const editedProfile = useSelector(selectEditedProfile);
  const dispatch: AppDispatch = useDispatch();
  const [userProfile, setUserProfile] = useState({
    id: editedProfile.id,
    img: editedProfile.img,
    gender_flg: editedProfile.gender_flg,
    username: editedProfile.username,
    height: editedProfile.height,
    height_hide_flg: editedProfile.height_hide_flg,
    weight: editedProfile.weight,
    weight_hide_flg: editedProfile.weight_hide_flg,
    text: editedProfile.text,
    calendar_hide_flg: editedProfile.calendar_hide_flg,
    newImg: new File([], ""),
  });
  //画像ライブプレビュー用
  const [userNewImg, setUserNewImg] = useState("");
  const [textCount, setTextCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isWide = useMedia({ minWidth: "600px" });
  //ラジオボタン制御
  const handleToggleRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserProfile({ ...userProfile, [e.target.name]: e.target.value });
  };
  //プロフィール画面へ戻る
  const backProfile = useCallback(() => {
    history.push("/home/profile");
  }, [history]);
  //画像をクリックした時、fileInputを起動させる
  const handleEditPicture = () => {
    const fileInput = document.getElementById("imageInput");
    fileInput?.click();
  };
  //textfiledの値変更用
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const name = e.target.name;
    setUserProfile({ ...userProfile, [name]: value });
  };
  //textareaの値変更用（typeが異なるため）
  //138文字以上は入力できないようにする
  const handleInputChangeTextarea = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    let textData = e.target.value;
    if (textData.length > 138) {
      textData = textData.slice(0, 138);
      setUserProfile({ ...userProfile, text: textData });
    } else {
      setUserProfile({ ...userProfile, text: e.target.value });
      setTextCount(textData.length);
    }
  };
  //登録ボタン押下時 アップデートの処理を実施し、画面を戻る
  const handleEditProfile = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true);
    e.preventDefault();
    await dispatch(fetchAsyncUpdateProfile(userProfile));
    setIsLoading(true);
    history.goBack();
  };
  //画像ライブプレビュー
  const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    let files = e.target.files;
    if (files) {
      let reader = new FileReader();
      reader.onload = () => {
        if (reader.result !== null) {
          setUserNewImg(String(reader.result));
        }
      };
      if (files[0]) {
        //画像表示
        reader.readAsDataURL(files[0]);
        //新しい画像が登録されるためstateに保存
        setUserProfile({ ...userProfile, newImg: files[0] });
      }
    }
  };
  //画面表示時にプロフィールデータを取得できない場合、profile画面へ
  useEffect(() => {
    editedProfile.id === 0 && history.push("/home/profile");
  }, []);
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} component={Paper} elevation={6} square>
        {isLoading && (
          <div className={classes.circulContainer}>
            <CircularProgress className={classes.circul} />
          </div>
        )}
        <form className={classes.form} onSubmit={handleEditProfile}>
          <div className={isWide ? classes.header : classes.headerRes}>
            <div className={classes.headerWhite}>
              <div className={classes.headerBack}>
                <ArrowBackIcon onClick={backProfile} />
              </div>
              <div className={classes.headerSubmit}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  登録
                </Button>
              </div>
            </div>
          </div>

          <Grid container xs={12} className={classes.paperContainer}>
            <div className={classes.bodyWhite}>
              <Grid item xs={12}>
                <div className={classes.avatarContainer}>
                  <input
                    type="file"
                    id="imageInput"
                    hidden={true}
                    onChange={handleChangeFile}
                  />
                  <button
                    onClick={handleEditPicture}
                    className={classes.avatarBtn}
                    type="button"
                  >
                    <div className={classes.imgSelect}>画像を選択</div>
                    {/* ライブプレビューが存在する時新しい画像を表示 */}
                    {userNewImg !== "" ? (
                      <Avatar
                        src={userNewImg}
                        alt="Icon"
                        className={classes.avatar}
                      />
                    ) : (
                      <Avatar
                        src={userProfile?.img ? userProfile?.img : undefined}
                        alt="Icon"
                        className={classes.avatar}
                      />
                    )}
                  </button>
                </div>
              </Grid>

              <TextField
                required
                id="username"
                label="名前(15文字以内)"
                variant="outlined"
                fullWidth
                margin="normal"
                value={userProfile.username}
                name="username"
                className={classes.color}
                onChange={handleInputChange}
                InputProps={{
                  inputProps: { maxLength: 15 },
                }}
              />
              <div className={classes.text}>
                性別・身長・体重を入力すると、あなたのステータスに近いユーザーを検索することができます。
              </div>
              <RadioGroup
                aria-label="gender"
                name="gender_flg"
                value={userProfile?.gender_flg ? userProfile?.gender_flg : 1}
                onChange={handleToggleRadio}
                className={classes.flex}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="設定なし"
                  className={classes.radioText}
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="男性"
                  className={classes.radioText}
                />
                <FormControlLabel
                  value="3"
                  control={<Radio color="primary" />}
                  label="女性"
                  className={classes.radioText}
                />
              </RadioGroup>

              <Box display="flex" alignItems="center" width={1}>
                <TextField
                  id="height"
                  label="身長(半角)※"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="height"
                  type="number"
                  className={classes.color}
                  onChange={handleInputChange}
                  value={userProfile?.height ? userProfile?.height : ""}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">cm</InputAdornment>
                    ),
                    inputProps: { min: 0, max: 300 },
                  }}
                />
              </Box>
              <div className={classes.textSub}>
                ※未設定に変更したい場合は、０を入力してください。
              </div>

              <Box display="flex" alignItems="center" width={1}>
                <TextField
                  id="weight"
                  label="体重(半角)※"
                  variant="outlined"
                  fullWidth
                  type="number"
                  margin="normal"
                  name="weight"
                  className={classes.color}
                  onChange={handleInputChange}
                  value={userProfile?.weight ? userProfile?.weight : ""}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">kg</InputAdornment>
                    ),
                    inputProps: { min: 0, max: 300 },
                  }}
                />
              </Box>
              <div className={classes.textSub}>
                ※未設定に変更したい場合は、０を入力してください。
              </div>

              <textarea
                aria-label="minimum height"
                name="text"
                rows={6}
                placeholder="プロフィールのコメント"
                className={classes.textarea}
                value={userProfile?.text ? userProfile?.text : ""}
                onChange={handleInputChangeTextarea}
              />
              <div className={classes.textCount}>{textCount}/138</div>

              <FormLabel className={classes.radioLabel}>
                カレンダーを他のユーザーに公開しますか?
              </FormLabel>
              <RadioGroup
                aria-label="calendar"
                name="calendar_hide_flg"
                value={
                  userProfile?.calendar_hide_flg
                    ? userProfile?.calendar_hide_flg
                    : undefined
                }
                onChange={handleToggleRadio}
                className={classes.flex}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="公開"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="非公開"
                />
              </RadioGroup>
            </div>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default ProfileEdit;
